import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDrawer} from '@angular/material/sidenav';
import {UserData} from '../authentication/user.model';
import {AuthenticationService} from '../authentication/authentication.service';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';
import {TenantService} from '../authentication/tenant.service';
import {ErrorModalComponent} from '../errorhandler/error-modal/error-modal.component';
import {TenantSelectComponent} from '../lead-form-app/tenant-select/tenant-select.component';
import {AgentService} from '../lead-form-app/service/agent.service';
import {MatDialog} from '@angular/material/dialog';
import {TngRedirectComponent} from '../tng-redirect/tng-redirect.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  @ViewChild('drawer', {static: true})
  public drawer: MatDrawer;

  user: UserData;

  errorMessage: string;

  loadingUser: boolean;

  constructor(private authenticationService: AuthenticationService, private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer, private router: Router, private tenantService: TenantService,
              private agentService: AgentService, private matDialog: MatDialog) {
    this.matIconRegistry.addSvgIcon(
      `lead_form`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(environment.deployUrl + 'assets/lead_form.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `tools`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(environment.deployUrl + 'assets/tools.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `change_password`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(environment.deployUrl + 'assets/change_password.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `plus`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(environment.deployUrl + 'assets/add.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `link`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(environment.deployUrl + 'assets/link.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `support`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(environment.deployUrl + 'assets/support.svg')
    );
    this.matIconRegistry.addSvgIcon(
      `history`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(environment.deployUrl + 'assets/historie.svg')
    );
    window.onresize = (e) => this.ngOnInit();
    authenticationService.triggerLogin();
    this.loadingUser = true;
    authenticationService.authenticatedUser.subscribe(user => {
      this.loadingUser = false;
      this.user = user;
      tenantService.getCurrentTenantInfo().subscribe(tenantInfo => {
        if (tenantInfo.id) {
          agentService.getAgentsOfCurrentUser().subscribe(
            agentPage => {
              const tenantId = agentPage._embedded.officeAllocations[0]._embedded.employee._embedded.company._embedded.tenant.id;
              if (!agentPage?._embedded?.officeAllocations) {
                this.errorMessage = 'Sie sind keinem Büro zugordnet.';
                // TODO: Option to change company?
              } else {
                matDialog.open(TngRedirectComponent, {data: {tenantId}});
              }
              if (tenantId !== user.tenant) {
                console.log('tenants do not match: ', user, agentPage._embedded.officeAllocations[0]._embedded.employee._embedded.company);
              }
            },
            error => matDialog.open(ErrorModalComponent, {data: error})
          );
        } else {
          agentService.getAgentsOfCurrentUser().subscribe(
            agentPage => {
              if (!agentPage?._embedded?.officeAllocations) {
                this.errorMessage = 'Sie sind keinem Büro zugordnet.';
              } else {
                const tenantIds: Set<string> = new Set<string>();
                agentPage._embedded.officeAllocations.map(oa => oa._embedded.employee._embedded.company._embedded.tenant.id).forEach(
                  tenantId => tenantIds.add(tenantId));
                if (tenantIds.size === 1) {
                  tenantService.redirectToSubdomain(tenantIds.values().next().value)
                    .subscribe(tenant => {
                    }, error => matDialog.open(ErrorModalComponent, {data: error}));
                } else {
                  matDialog.open(TenantSelectComponent, {data: tenantIds, disableClose: true, minHeight: '90%'});
                }

              }
            },
            error => matDialog.open(ErrorModalComponent, {data: error})
          );
        }
      }, error => matDialog.open(ErrorModalComponent, {data: error}));
    });

  }

  passwordChange() {
    this.authenticationService.passwordChange();
  }

  logout() {
    this.authenticationService.logout();
  }

  ngOnInit(): void {
    if (window.innerWidth < 601) {
      this.drawer.close();
    } else {
      this.drawer.open();
    }
  }

  isActive(link: string) {
    return this.router.isActive(link, true);
  }


  menuItemClicked() {
    if (window.innerWidth < 601) {
      this.drawer.close();
    }
  }
}
